export default {
    leaveType: 'Leave Type',
    gender: 'Gender',
    numberOfDays: 'Days',
    resetDay: 'Reset Day',
    resetMonth: 'Reset Mouth',
    employment: 'Employment',
    searchLeaveTypes: 'Search Leave Type',
    search: 'Search',
    fullTimeLeave: 'Full-Time Leave',
    personalLeave: 'Personal Leave',
    sickLeave: 'Sick Leave',
    annualResetDate: 'Annual Reset Date',
    saveChanges: 'Save Changes',
    probation: 'Probation',
    probationLeave: 'Probation Leave',
    congratulation: 'Congratulation',
    action: 'Action',
    createLeaveType: 'Create Leave Type',
    deleteLeaveType: 'Delete Leave Type',
    wantToDelete: 'Are you sure you want to delete',
    leaveTypeIsDeleted: 'Leave Type is deleted'
}
